module.exports = __webpack_public_path__ + "5f95c47d62d83a389e0b02fcdf039507.MP3";